export default __webpack_public_path__ + "static/media/card7.39c88297.png";